import Header from './Header';

const PageWrapper = ({ children }) => {
    return (
        <>
            <Header />
            <div className="h-16" />
            <main className="min-h-[calc(100vh-64px)] bg-gray-50 pb-8 flex flex-col overflow-y-auto">
                {children}
            </main>
        </>
    );
};

export default PageWrapper;
